module.exports = __webpack_public_path__ + "media/images/dmc/city-osaka-e4a85b9e790c7a56ce88c47256985a48.jpg";